import { getServiceRate } from 'client/fetch/serviceRate';
import { Spinner } from 'components/Spinner';
import { services } from 'constants/services';
import React from 'react';
const ServiceInfo = ({ serviceId, stateId }) => {
    const [serviceRate, setServiceRate] = React.useState({ isFetching: true });
    getServiceRate(setServiceRate, stateId, serviceId);
    const staticInfo = services.find((data) => data.id === serviceId);
    if (!serviceRate.data || !staticInfo) {
        return React.createElement(Spinner, null);
    }
    const service = Object.assign(Object.assign({}, serviceRate.data), { staticInfo });
    return (React.createElement("div", { className: "service-fees-sub" },
        React.createElement("h3", null, service.staticInfo.name.toUpperCase()),
        React.createElement("div", { className: "ser-portion" },
            React.createElement("div", { className: "left-service-fees" },
                React.createElement("img", { alt: service.staticInfo.name, src: service.staticInfo.img })),
            React.createElement("div", { className: "right-service-fees" },
                React.createElement("div", { className: "service-text" },
                    React.createElement("p", null, "Attorneys in Motion\u2019s attorneys are dedicated and diligent when it comes to handling and covering your hearing. Most of our local attorneys have long-standing relationships with the judges and clerks and are familiar with the local court policies and procedures.")),
                React.createElement("div", { className: "bottom-service-txt" },
                    React.createElement("ul", { className: "ser-details" }, service.appearanceTypes.map((appearance) => (React.createElement("li", { key: appearance.id },
                        React.createElement("span", { className: "ser-text" }, appearance.name),
                        React.createElement("span", { className: "ser-fees" },
                            "$",
                            appearance.fee.toFixed(2),
                            appearance.feeType === 'hourly' && '/hourly')))))))),
        React.createElement("div", { className: "important-notification" },
            React.createElement("div", { className: "imp-info" },
                React.createElement("h4", null, "Important fee information:"),
                React.createElement("p", null, "Most appearances are a flat fee unless the below applies. There are no fees for parking, telephone, fax or copy.")),
            React.createElement("div", { className: "additional-fees" },
                React.createElement("h4", null, "Additional Fees"),
                React.createElement("p", null, "All hourly based appearances are billed at a 2 hour minimum."),
                React.createElement("ul", { className: "fees-strusture" },
                    React.createElement("li", null,
                        React.createElement("p", null, "Data storage fee for each appearance"),
                        React.createElement("span", null,
                            "$",
                            service.processingFees[0].fee.toFixed(2))),
                    service.rushFees.map((rushFee) => (React.createElement("li", { key: rushFee.id },
                        React.createElement("p", null,
                            "Rush fee/Requested within",
                            ' ',
                            rushFee.withinHour,
                            ' ',
                            "hours of an appearance"),
                        React.createElement("span", null,
                            "$",
                            rushFee.fee.toFixed(2))))),
                    React.createElement("li", null, "Please note that there are some courts in obscure areas that require an additional out of area coverage fee."))))));
};
export default ServiceInfo;
